import type { CSSProperties, JSX, ReactNode } from "react";
import { cx } from "../cx";

export type BadgeTone = "verified" | "neutral" | "success" | "warning" | "error" | "dark";

export interface BadgeProps {
  /** `verified` is the only volt tone — reserve it for actually-verified states. */
  tone?: BadgeTone | undefined;
  /** Mono type for code-ish content. */
  mono?: boolean | undefined;
  className?: string | undefined;
  style?: CSSProperties | undefined;
  children?: ReactNode | undefined;
}

/**
 * Status pill — the only pill shape in the system. Ported from
 * design/tarski-kit/components/display/Badge.jsx.
 */
export function Badge({
  tone = "neutral",
  mono = false,
  className,
  style,
  children,
}: BadgeProps): JSX.Element {
  return (
    <span
      className={cx("tk-badge", `tk-badge--${tone}`, mono && "tk-badge--mono", className)}
      style={style}
    >
      {children}
    </span>
  );
}
